import { Button, Grid, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import CustomContainer from '../../../components/common/CustomContainer'
import CustomTextField from '../../../components/common/CustomTextField'
import TimeSpanTextField from '../../../components/common/TimeSpanTextField'
import { EmailAutomationSettingsDto } from '../../../services/api/sharedTypes/EmailAutomationSettings'
import { convertEmailAutomationSettingsToString } from '../../../utils/email-utils'

interface EmailSettingsProps {
    emailAutomationSettings: EmailAutomationSettingsDto
    onChange: (emailAutomationSettings: EmailAutomationSettingsDto) => void
    onSave: (emailAutomationSettings: EmailAutomationSettingsDto) => void
}

const EmailSettings: React.FC<EmailSettingsProps> = ({ emailAutomationSettings, onChange, onSave }: EmailSettingsProps) => {
    const theme = useTheme()

    return (
        <CustomContainer maxWidth={'50%'} disableCentering bgColor={theme.palette.background.default}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Stack>
                    <Typography variant='h6'>Nastavení časových podmínek automatizace</Typography>

                    <Typography variant='caption' mb={2}>
                        (Formát hodiny:minuty)
                    </Typography>
                </Stack>
                <Button variant='contained' onClick={() => onSave(emailAutomationSettings)}>
                    <Typography variant='body1'>Uložit</Typography>
                </Button>
            </Stack>

            <Grid container spacing={3}>
                {Object.keys(emailAutomationSettings).map((key) => {
                    const value = emailAutomationSettings[key as keyof EmailAutomationSettingsDto]
                    const label = convertEmailAutomationSettingsToString(key as keyof EmailAutomationSettingsDto)
                    if (typeof value === 'number') {
                        return (
                            <Grid item md={6} xs={12} key={key}>
                                <Stack>
                                    <Typography variant='body1' mb={1}>
                                        {label}
                                    </Typography>
                                    <CustomTextField
                                        style={{
                                            maxWidth: '100px',
                                        }}
                                        value={value ?? ''}
                                        onChange={(event) => {
                                            if (isNaN(Number(event.target.value))) return
                                            onChange({
                                                ...emailAutomationSettings,
                                                [key]: Number(event.target.value),
                                            })
                                        }}
                                    />
                                </Stack>
                            </Grid>
                        )
                    }
                    return (
                        <Grid item md={6} xs={12} key={key}>
                            <TimeSpanTextField
                                label={label}
                                value={value}
                                onChange={(value) => {
                                    onChange({
                                        ...emailAutomationSettings,
                                        [key]: value,
                                    })
                                }}
                            />
                        </Grid>
                    )
                })}
            </Grid>
        </CustomContainer>
    )
}

export default EmailSettings
